// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"3477dee0","453":"a27d1ef7","494":"431f1ebe","919":"0575013b"}[chunkId] + ".chunk.js";
};